<template>
  <div class="box">
    <CustomNavBar :title="$route.query.type === 'culture' ? '文旅线路' : '产业线路'" />
    <div class="list">
      <component :is="$route.query.type" :key="$route.query.type" :data="data" />
    </div>
    <img class="bg-img1" :src="require('@/assets/bg01.png')">
  </div>
</template>

<script>
import CustomNavBar from "@/components/CustomNavBar";
import culture from "@/components/CustomSwiper/swiper2.vue";
import industrial from "@/components/CustomSwiper/swiper1.vue";

import { scenicList } from '@/api/scenic'
export default {
  name: "CATE",
  components: {
    CustomNavBar,
    culture,
    industrial
  },
  data() {
    return {
      data: null
    };
  },
  watch: {
    $route(to, from) {
      if (to.query.type !== from.query.type) {
        this.data = null
        this.getData(to.query)
      }
    },
  },
  created() {
    this.getData(this.$route.query)
  },
  mounted() {
    this.$store.commit('set_istab', true)
  },
  methods: {
    getData(query) {
      scenicList(query).then((ret) => {
        this.data = ret
      })
    },

  },
};
</script>

<style lang="scss" scoped>
.box {
  background: #f5f7fa;
  height: 100%;
  position: relative;

  .bg-img1 {
      position: absolute;
      left: 0;
      bottom: 50px;
      width: 200px;
      height: auto;
    }

  .list {
    box-sizing: border-box;
    height: calc(100% - 96px);
  }
}
</style>
